// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__FInyv","row":"ProcedureTreatmentSummary_row__2Mk-q"};